export default __webpack_public_path__ + "static/media/soccer-ball.50b438e1.png";